import ModalNames from "./ModalNames";
import { Modal } from "@/models/Modal";

export default class Modals {
  static COVERED_MODAL: Modal = {
    label: ModalNames.COVERED_MODAL,
    path: "CoveredModal.vue",
  };
  // static COVERED_MODAL_1 = "covered-1";
  // static COVERED_MODAL_2 = "covered-2";
  static FILE_CLAIM_MODAL: Modal = {
    label: ModalNames.FILE_CLAIM_MODAL,
    path: "FileAClaimModal.vue",
  };
  static MY_POLICY_MODAL: Modal = {
    label: ModalNames.MY_POLICY_MODAL,
    path: "MyPolicyModal.vue",
  };
  static FAQ_MODAL: Modal = {
    label: ModalNames.FAQ_MODAL,
    path: "FaqModal.vue",
  };
  static PARTNERSHIPS_MODAL: Modal = {
    label: ModalNames.PARTNERSHIPS_MODAL,
    path: "PartnershipsModal.vue",
  };
  static CONTACT_MODAL: Modal = {
    label: ModalNames.CONTACT_MODAL,
    path: "ContactNssiModal.vue",
  };
  static ACCIDENTAL_DAMAGE_MODAL: Modal = {
    label: ModalNames.ACCIDENTAL_DAMAGE_MODAL,
    path: "AccidentalDamageModal.vue",
  };
  static ADD_INTERESTED_PARTY: Modal = {
    label: ModalNames.ADD_INTERESTED_PARTY,
    path: "AddInterestedParty.vue",
  };
  static ADD_USER_MODAL: Modal = {
    label: ModalNames.ADD_USER_MODAL,
    path: "AddUserModal.vue",
  };
  static ELECTRONIC_CONSENT_MODAL: Modal = {
    label: ModalNames.ELECTRONIC_CONSENT_MODAL,
    path: "ElectronicConsentModal.vue",
  };
  static DISCLOSURES_MODAL: Modal = {
    label: ModalNames.DISCLOSURES_MODAL,
    path: "DisclosuresModal.vue",
  };
  static PAYMENT_AUTHORIZATION_MODAL: Modal = {
    label: ModalNames.PAYMENT_AUTHORIZATION_MODAL,
    path: "PaymentAuthorizationModal",
  };
}
